import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import { SuspendSubscriber } from 'app/components/icons'

import { SUBMIT } from 'app/constants/button'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const Suspend = (props) => {
  const { closeMenu, onAction } = props

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <>
      <MenuItem onClick={() => handleOpen()} className="space-x-5">
        <SuspendSubscriber classes="w-auto" />
        <Typography className="text-14 font-400 text-primary">
          {formatMessage({
            id: 'teamMembers.lable.suspend',
          })}
        </Typography>
      </MenuItem>
      <SubmitDialog
        id="dialog-suspend-team-member"
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'teamMembers.suspend.title',
        })}
        description={formatMessage({
          id: 'teamMembers.suspend.description',
        })}
        submitText={formatMessage({
          id: 'teamMembers.lable.suspend',
        })}
        onSubmit={async () => {
          await onAction()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </>
  )
}

Suspend.propTypes = {
  onAction: PropTypes.func,
  closeMenu: PropTypes.func,
}

export default Suspend
